<template>
    <v-app-bar
        app
		color="primary"
		class="px-xs-5 elevation-0"
		height="40"
        dir="rtl"
    >
        <v-row>
            <v-col class="px-0"></v-col>
            <v-col class="d-flex justify-center px-0">
                <span class="white--text">
                    {{ titles[$route.name] }}
                </span>
            </v-col>
            <v-col class="d-flex justify-end px-0" align-self="center">
                <v-btn v-if="$route.name === 'student-page'" small icon :to="{ name: 'notification', query: { isStart: $route.query.isStart } }">
                    <v-badge
                        color="pink"
                        dot
                        overlap
                        left
                    >
                        <v-icon size="22" color="white"> mdi-bell </v-icon>
                    </v-badge>
                </v-btn>

                <v-btn small icon @click="dialog = true">
                    <v-icon color="white"> mdi-logout </v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!-- dialog -->
        <v-dialog
            v-model="dialog"
            width="350"
        >
            <v-card class="rounded-BigLg">
                <v-card-title class="text-h5 pb-0 pt-1 px-2" >
                    <v-btn small icon @click="dialog = false">
                        <v-icon color="grey" small> mdi-close </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-center ">
                    <v-icon color="primary" class="my-1"> mdi-logout </v-icon>
                    <h3 class="my-1"> تسجيل الخروج </h3>
                    هل أنت متأكد أنك تود تسجيل الخروج؟
                </v-card-text>

                <v-card-actions class="d-flex justify-center">
                    <div>
                        <v-btn small color="primary" @click="logout()">
                            تسجيل الخروج
                        </v-btn>

                        <v-btn small text @click="dialog = false">
                            إلغاء
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
        return {
            dialog: false,
            titles: {
                'student-page': 'الطلاب',
                messages: 'الرسائل',
                notification: 'الإشعارات'
            }
        }
    },
    computed: {
        ...mapState({
            info: state => state.auth.info
        })
    },

    methods: {
        logout () {
            this.$store.dispatch('auth/logout')
			delete window.axios.defaults.headers.common['X-Password']
            this.$router.replace({ name: 'login' })
        }
    }
}
</script>

<style scoped>
</style>
